// import { useRoutes } from "react-router-dom";
// import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import React, { useState, useEffect } from "react";
import { Route, Routes } from "react-router";
import './App.css';
import Login from "./pages/login";
import Dashboard from "./pages/dashboard";
import Clients from "./pages/clients";
import Users from "./pages/users";
import { pageRoutes } from "./routes/PageRoute";
import SessionTimeout from "./components/SessionTimeout";
import { getAuth } from "./utils/pipe";
import Projects from "./pages/projects/projects";
import AssignUser from "./pages/assign-user";
import ProjectUsers from "./pages/projects/project-users";
import TeamUsers from "./pages/team-users";
import DailyTimesheet from "./pages/timesheet/daily-timesheet";
import MonthlyTimesheet from "./pages/timesheet/monthly-timesheet";
import WeeklyTimesheet from "./pages/timesheet/weekly-timesheet";
import Reports from "./pages/reports";
import Effortestimatedetail from "./pages/effortestimatedetail";
import ImportTimeSheet from "./pages/timesheet/import-timesheet"; 
// const AppRoutes = () => {
//   return useRoutes([
//     { path: "/login", element: <Login /> },
//     { path: "/dashboard", element: <Dashboard /> },
//     { path: "/timesheet/daily", element: <DailyTimesheet /> },
//     // { path: "/timesheet/weekly", element: <WeeklyTimesheet /> },
//     // { path: "/timesheet/monthly", element: <MonthlyTimesheet /> },
//     { path: "/clients", element: <Clients /> },
//     { path: "/projects/create", element: <CreateProject /> },
//     { path: "/projects/project-users", element: <ProjectUsers /> },
//     { path: "/users/create", element: <CreateUser /> },
//     { path: "/users/team-users", element: <TeamUsers /> }
//   ]);
// };

function App() {

  const isLogin = getAuth();

  const [isToggle, setIsToggle] = useState(true);
  const handleToggleSidebar = () => {
    setIsToggle(!isToggle);
  };

  return (
    <>
      <div>
        <SessionTimeout />
        <Routes>
          <Route path={pageRoutes.login} exact element={<Login />} />
          <Route path={pageRoutes.dashboard} exact element={<Dashboard />} />
          <Route path={pageRoutes.users} exact element={<Users />} />
          <Route path={pageRoutes.clients} exact element={<Clients />} />
          <Route path={pageRoutes.projects} exact element={<Projects />} />
          <Route path={pageRoutes.assignuser} exact element={<AssignUser />} />
          <Route path={pageRoutes.projectuser} exact element={<ProjectUsers />} />
          <Route path={pageRoutes.teamusers} exact element={<TeamUsers />} />
          <Route path={pageRoutes.daily} exact element={<DailyTimesheet />} />
          <Route path={pageRoutes.monthly} exact element={<MonthlyTimesheet />} />
          <Route path={pageRoutes.weekly} exact element={<WeeklyTimesheet />} />
          <Route path={pageRoutes.reports} exact element={<Reports />} />
          <Route path={pageRoutes.projectdetails} exact element={<Effortestimatedetail />} />
          <Route path={pageRoutes.ImportTimeSheet} exact element={<ImportTimeSheet />} />
          
        </Routes>
      </div>
      {/* <BrowserRouter>
        <AppRoutes />
      </BrowserRouter> */}
    </>
  );
}

export default App;
